import { makeStyles } from "@material-ui/core/styles";

import { drawerWidth } from "./RightUnitDrawerStyles";


export const useStyles = makeStyles((theme) => ({
    cameras: {
        marginTop: "0.75em",
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        columnGap: "0.7em",
        rowGap: "0.7em",
    },
    [`@media (max-width: ${drawerWidth})`]: {
        cameras: {
            gridTemplateColumns: "1fr",
        },
    },
    head: {
        fontWeight: "bold",
        fontSize: 20,
        color: theme.palette.grey[900],
    },
}));
